export const AttDisabledInstallationDates = [
  '09/01/2025',
  '10/12/2025',
  '11/27/2025',
  '11/28/2025',
  '11/29/2025',
];

export const CoxDisabledInstallationDates = [
  '09/01/2025',
  '11/27/2025',
  '11/28/2025',
  '11/29/2025',
];

export const SpectrumDisabledInstallationDates = [
  '07/04/2025',
  '07/05/2025',
  '09/01/2025',
  '09/02/2025',
  '11/27/2025',
  '11/28/2025',
  '11/29/2025',
];

export const XfinityDisabledInstallationDates = [
  '09/01/2025',
  '11/27/2025',
  '11/28/2025',
  '11/29/2025',
];
